import { JSX } from 'react'

import { IconProps } from '../../icon'

const ActColaborativa: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 33 32'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <g clipPath='url(#clip0_908_18)'>
      <path
        d='M3.61271 29.7614C5.58326 29.74 7.16826 28.1336 7.14684 26.163C7.12542 24.1925 5.519 22.6075 3.54845 22.6289C1.5779 22.6503 -0.00710534 24.2567 0.0143137 26.2273C0.0357327 28.1978 1.64216 29.7828 3.61271 29.7614Z'
        fill='#8DA3B0'
      />
      <path
        d='M3.74121 22.072C3.74121 22.072 5.66892 22.2434 6.84697 23.9141C7.7894 25.0921 7.57521 27.3411 7.57521 27.3411C7.57521 27.3411 10.1669 29.3116 14.4721 27.4696L9.6957 22.3505L9.43867 17.8096L14.5792 16.3531C14.5792 16.3531 16.2071 15.989 16.0357 14.4254C15.8858 13.2046 13.851 13.7829 13.851 13.7829C13.851 13.7829 8.83893 14.6182 6.93264 16.3531C5.04777 18.0452 4.16959 19.3518 3.74121 22.072Z'
        fill='#8DA3B0'
      />
      <path
        d='M30.6006 24.7922C29.6368 23.0787 27.4521 22.4789 25.7385 23.4642C24.025 24.4281 23.4253 26.6128 24.4106 28.3263C25.3744 30.0398 27.5592 30.6396 29.2727 29.6543C30.9648 28.669 31.5645 26.5057 30.6006 24.7922Z'
        fill='#5D7784'
      />
      <path
        d='M23.8108 28.4334C23.8108 28.4334 23.0183 26.6771 23.9179 24.835C24.4962 23.4428 26.5739 22.5218 26.5739 22.5218C26.5739 22.5218 27.0237 19.2875 23.3182 16.4388L21.1763 23.0787L17.3209 25.5204L13.5297 21.7721C13.5297 21.7721 12.4159 20.5298 11.1522 21.4508C10.1455 22.1791 11.6662 23.6784 11.6662 23.6784C11.6662 23.6784 14.8363 27.6409 17.278 28.4548C19.6555 29.2473 21.2405 29.3759 23.8108 28.4334Z'
        fill='#5D7784'
      />
      <path
        d='M12.8229 3.78016C11.8376 5.47226 12.4159 7.657 14.108 8.66369C15.8001 9.64897 17.9848 9.07065 18.9915 7.37855C19.9768 5.68645 19.3985 3.50171 17.7064 2.49502C15.9929 1.48832 13.8081 2.06664 12.8229 3.78016Z'
        fill='#46606C'
      />
      <path
        d='M19.3985 7.80695C19.3985 7.80695 18.2847 9.37053 16.2285 9.52047C14.7292 9.71324 12.9086 8.38526 12.9086 8.38526C12.9086 8.38526 9.88849 9.60614 9.28876 14.2541L16.1 12.7762L20.1268 14.8538L18.7774 20.0158C18.7774 20.0158 18.2633 21.6008 19.6984 22.2434C20.8336 22.7574 21.3691 20.6798 21.3691 20.6798C21.3691 20.6798 23.2111 15.9462 22.6756 13.4187C22.183 10.9984 21.4976 9.5633 19.3985 7.80695Z'
        fill='#46606C'
      />
    </g>
    <defs>
      <clipPath id='clip0_908_18'>
        <rect
          width='32'
          height='32'
          fill='white'
          transform='translate(0.0140991)'
        />
      </clipPath>
    </defs>
  </svg>
)

export default ActColaborativa
